module.exports = __webpack_public_path__ + "static/media/Preview_iOS_Notification_Image.787089c7.png";